(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-about-gallery"] && !Shopify.designMode) return;
  try {
    
    (function(){
      const root  = document.getElementById('st-about-{{ section.id }}');
      if(!root) return;

      const track = root.querySelector('.st-gallery');
      const slides = [...root.querySelectorAll('.st-item')];
      const dots   = [...root.querySelectorAll('.st-dot')];
      if(!track || slides.length === 0 || dots.length === 0) return;

      const mq = window.matchMedia('(max-width: 640px)');

      let mobileInitialized = false;
      let onScroll, onDotClick;
      let autoTimer = null;
      let current = 0;

      function activate(i){
        dots.forEach(d => d.classList.remove('is-active'));
        if(dots[i]) dots[i].classList.add('is-active');
        current = i;
      }
      function centerTo(i, behavior='smooth'){
        const idx = Math.max(0, Math.min(i, slides.length - 1));
        const s = slides[idx];
        const left = s.offsetLeft - (track.clientWidth - s.clientWidth)/2;
        track.scrollTo({ left, behavior });
        activate(idx);
      }

      function startAutoplay(){
        const shouldAuto = track.dataset.autoplay === 'true';
        const interval = parseInt(track.dataset.interval || '4000', 10);
        if(!shouldAuto || isNaN(interval) || interval < 1200) return;
        stopAutoplay();
        autoTimer = setInterval(() => {
          const next = (current + 1) % slides.length;
          centerTo(next);
        }, interval);
      }
      function stopAutoplay(){
        if(autoTimer){ clearInterval(autoTimer); autoTimer = null; }
      }

      function initMobile(e){
        if(!e.matches){
          if(mobileInitialized){
            track.removeEventListener('scroll', onScroll, { passive:true });
            dots.forEach(btn => btn.removeEventListener('click', onDotClick));
            stopAutoplay();
            mobileInitialized = false;
          }
          return;
        }
        if(mobileInitialized) return;

        let ticking = false;
        onScroll = () => {
          if(ticking) return; ticking = true;
          window.requestAnimationFrame(() => {
            const center = track.scrollLeft + track.clientWidth/2;
            let best = 0, bestDist = Infinity;
            slides.forEach((s, i) => {
              const c = s.offsetLeft + s.clientWidth/2;
              const d = Math.abs(c - center);
              if(d < bestDist){ bestDist = d; best = i; }
            });
            activate(best);
            ticking = false;
          });
          stopAutoplay();
        };
        track.addEventListener('scroll', onScroll, { passive:true });

        onDotClick = (ev) => {
          const i = parseInt(ev.currentTarget.dataset.to, 10) || 0;
          centerTo(i);
          stopAutoplay();
          setTimeout(startAutoplay, 2500);
        };
        dots.forEach(btn => btn.addEventListener('click', onDotClick));

        centerTo(0, 'auto');
        startAutoplay();

        let resizeTO;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTO);
          resizeTO = setTimeout(() => centerTo(current, 'auto'), 200);
        });

        document.addEventListener('visibilitychange', () => {
          if(document.hidden) stopAutoplay(); else startAutoplay();
        });

        mobileInitialized = true;
      }

      initMobile(mq);
      mq.addEventListener('change', initMobile);
    })();
  
  } catch(e) { console.error(e); }
})();
})();
